import { http } from '@/utils/http/axios';

export function requestStore(params) {
  return http.request({
    url: '/auth/tokens',
    method: 'POST',
    params,
  });
}
